var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","dark":"","small":"","color":"light"},on:{"click":_vm.toggle}},[_c('v-icon',{attrs:{"color":"#2b2b2b"}},[_vm._v(" "+_vm._s(_vm.hidden ? "mdi-eye-off" : "mdi-eye")+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }